import { Box, FieldLabel, Stack, Text } from 'braid-design-system';
import { format } from 'date-fns/format';
import type React from 'react';

import * as styles from './styles.css';

interface DatePickerProps {
  name: string;
  type: 'date' | 'datetime-local';
  value?: Date;
  max?: Date;
  min?: Date;
  label?: string;
  secondaryLabel?: string;
  errorMessage?: string;
  onChange?: (name: string, isoDate?: Date) => void;
}

export const DatePicker = (props: DatePickerProps) => {
  const {
    name,
    label,
    value,
    min,
    max,
    type,
    onChange,
    secondaryLabel,
    errorMessage,
  } = props;
  const dateFormat = type === 'date' ? 'yyyy-MM-dd' : "yyyy-MM-dd'T'HH:mm:ss";
  const formattedDate = value ? format(value, dateFormat) : '';
  const formattedMax = max ? format(max, dateFormat) : '';
  const formattedMin = min ? format(min, dateFormat) : '';

  return (
    <Stack space="small">
      {label ? (
        <FieldLabel
          htmlFor={name}
          label={label}
          secondaryLabel={secondaryLabel}
        />
      ) : null}
      <Text size="small">
        <Box
          component="input"
          type={type}
          id={name}
          name={name}
          value={formattedDate}
          max={formattedMax}
          min={formattedMin}
          className={styles.datePicker}
          background="surface"
          borderRadius="standard"
          boxShadow={errorMessage ? 'borderCritical' : 'borderField'}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const newValue =
              type === 'date' ? e.target.valueAsDate : new Date(e.target.value);

            if (newValue && !isNaN(newValue.getTime()) && onChange) {
              onChange(name, newValue);
            }
          }}
          paddingX="small"
          paddingY="xsmall"
          width="full"
        />
      </Text>
      {errorMessage ? (
        <Text size="small" tone="critical">
          {errorMessage}
        </Text>
      ) : null}
    </Stack>
  );
};
